import { Grid } from '@mui/material';
import React, { useCallback, useContext, useMemo } from 'react';
import { Add as AddIcon, Assignment, Print } from '@mui/icons-material';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import { ApplicationFeaturesContext } from 'providers/ApplicationFeaturesContext';
import { GlobalRightsContext } from 'providers/GlobalRightsContext';
import { IconButton } from '@totalsoft/rocket-ui';
import HeaderOffer from './HeaderOffer';

const HeaderDropdown = props => {
  const { t, history, location } = props;

  const { bulkResponsibleAssignation, enableClientFacility, enableContractChanges } = useContext(ApplicationFeaturesContext);
  const {
    addNewOffer,
    addRestructuringOffer,
    addFolder,
    addFacilityFolder,
    addFacilityOffer,
    addFacility,
    offerBulkResponsbileAllocation,
    folderBulkResponsbileAllocation,
    offerBulkPrintRead
  } = useContext(GlobalRightsContext);

  const navigateTo = useCallback(route => () => history.push(route), [history]);

  const offerOptionsAvailability = useMemo(() => {
    return {
      addOffer: addNewOffer,
      addContractModification: enableContractChanges && addRestructuringOffer,
      addFacilityFrame: enableClientFacility && addFacilityOffer
    };
  }, [addFacilityOffer, addNewOffer, addRestructuringOffer, enableClientFacility, enableContractChanges]);

  return (
    <>
      {location.pathname === '/offers' && (
        <Grid container spacing={1} justifyContent='flex-end' px={2}>
          <Grid item>
            <HeaderOffer offerOptionsAvailability={offerOptionsAvailability} history={history} />
          </Grid>
          {bulkResponsibleAssignation && (
            <Grid item>
              <IconButton
                color='warning'
                variant='text'
                tooltip={t('Tooltips.OffersResponsibleChange')}
                onClick={navigateTo('/offers/responsibleChange')}
                disabled={!offerBulkResponsbileAllocation}
                id={'header_allocateOffersBtn'}
              >
                <Assignment />
              </IconButton>
            </Grid>
          )}
          {offerBulkPrintRead && (
            <Grid item>
              <IconButton
                variant='text'
                tooltip={t('Tooltips.BulkPrinting')}
                onClick={navigateTo('/offers/bulkPrint')}
                id={'header_bulkPrintBtn'}
              >
                <Print />
              </IconButton>
            </Grid>
          )}
        </Grid>
      )}
      {location.pathname === '/facilities' && enableClientFacility && (
        <Grid container spacing={1} justifyContent='flex-end' px={2}>
          <Grid item>
            <IconButton
              variant='text'
              tooltip={t('Tooltips.AddNewFacility')}
              onClick={navigateTo('/facilities/new')}
              disabled={!addFacility}
              id={'header_addNewFacilityBtn'}
            >
              <AddIcon />
            </IconButton>
          </Grid>
        </Grid>
      )}
      {location.pathname === '/folders' && (
        <Grid container spacing={1} justifyContent='flex-end' px={2}>
          <Grid item>
            <IconButton
              color='info'
              variant='text'
              tooltip={t('Tooltips.AddNewFolder')}
              onClick={navigateTo('/folders/new')}
              disabled={!addFolder}
              id={'header_addNewFolderBtn'}
            >
              <AddIcon />
            </IconButton>
          </Grid>
          {enableClientFacility && (
            <Grid item>
              <IconButton
                color='success'
                variant='text'
                tooltip={t('Tooltips.AddNewFacilityApprovalFolder')}
                onClick={navigateTo('/folders/facilityApproval/new')}
                disabled={!addFacilityFolder}
              >
                <AddIcon />
              </IconButton>
            </Grid>
          )}
          <Grid item>
            <IconButton
              color='warning'
              variant='text'
              tooltip={t('FolderAllocateResponsible.AddResponsible')}
              onClick={navigateTo('/folders/responsibleChange')}
              disabled={!folderBulkResponsbileAllocation}
            >
              <Assignment />
            </IconButton>
          </Grid>
        </Grid>
      )}
      {location.pathname === '/partner-files' && (
        <Grid container spacing={1} justifyContent='flex-end' px={2}>
          <Grid item>
            <IconButton
              color='info'
              variant='text'
              tooltip={t('Tooltips.AddNewPartnerFile')}
              onClick={navigateTo('/partner-files/new')}
              id={'header_addNewPartnerFileBtn'}
            >
              <AddIcon />
            </IconButton>
            <IconButton
              color='success'
              variant='text'
              tooltip={t('Tooltips.AddNewBulkFile')}
              onClick={navigateTo('partner-files/new-bulk')}
              id={'header_addNewBulkFileBtn'}
            >
              <AddIcon />
            </IconButton>
          </Grid>
        </Grid>
      )}
    </>
  );
};

HeaderDropdown.propTypes = {
  t: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired
};

export default compose(withRouter, withTranslation())(HeaderDropdown);
